import React from "react";

export type DetailData = {
  file_type: string;
  file_name: string;
  file_path: string;
  thumbnail: string;
  link?: string;
  text?: string;
  asset_title?: string;
};

export type Message = {
  event?: {
    error_code: number;
  };
  model: string;
  answer: string[];
  url: string[];
  asset_data: DetailData[];
  ai_question?: string; // AI提案質問テキスト
  asset_description?: string; // アセット説明テキスト
  campaign_text?: string; // キャンペーンテキスト（4行フォーマット）
  cta_data?: any[]; // CTAデータ
  need_cta?: boolean; // trueの時のみ「ご相談はこちら」を表示
  display_link?: any[]; // 本文関連リンク（{anchor_text, url}の配列、display_text直後にアンカーテキストで表示）
  banner_cta_data?: any[]; // バナーCTAデータ（セッションリセット時に表示）
  answers_used?: boolean;
  streaming_completed?: boolean | 'text_completed'; // false: ストリーミング中, 'text_completed': テキスト完了, true: 完全完了
};
export type ChatLog = {
  message: Message;
  type: "AI" | "USER" | "LOADING";
  id?: string; // ストリーミング中のAIメッセージを一意に識別するID（並行送信時の混線防止）
};

type ChatLogContextType = {
  chatLogs: ChatLog[];
  setChatLogs: React.Dispatch<React.SetStateAction<ChatLog[]>>;
  resetIdleTimer: () => void;
};

export const ChatLogContext = React.createContext<
  ChatLogContextType | undefined
>(undefined);
